import MapFeature from './MapFeature'

/**
 * Adds UX and event handling to make features on certain map layers clickable.
 */
export default class ClickableFeatures extends MapFeature {

    /** @type {string[]} */
    _layerIds

    /**
     * @param {...string[]} layerIds One or more layer IDs
     */
    constructor(...layerIds) {
        super()

        this._layerIds = layerIds

        this._handleClick = this._handleClick.bind(this)
        this._handleMouseEnter = this._handleMouseEnter.bind(this)
        this._handleMouseLeave = this._handleMouseLeave.bind(this)
    }

    _onAdd(map) {
        for (const layerId of this._layerIds) {
            map.on('click', layerId, this._handleClick)
            map.on('mouseenter', layerId, this._handleMouseEnter)
            map.on('mouseleave', layerId, this._handleMouseLeave)
        }
    }

    _onRemove(map) {
        for (const layerId of this._layerIds) {
            map.off('click', layerId, this._handleClick)
            map.off('mouseenter', layerId, this._handleMouseEnter)
            map.off('mouseleave', layerId, this._handleMouseLeave)
        }
    }

    /**
     * @param {import("maplibre-gl").MapMouseEvent} e
     */
    _handleClick(e) {
        this._dispatchEvent('click', e)
    }

    _handleMouseEnter() {
        this._map.getCanvas().classList.add('pointer')
    }

    _handleMouseLeave() {
        this._map.getCanvas().classList.remove('pointer')
    }

}
